import React, { useEffect, useState } from 'react'
import { getLinksByText } from '../../../../../../helpers/link/LinkHelper'
import SupplyOrderItemLink from './SupplyOrderItemLink'

const SupplyOrderItemLinks = ({ links }) => {

    const [linkList, setLinkList] = useState([])

    // console.log('linkList', linkList)

    useEffect(() => {
        changeLinks()
    }, [links])

    const changeLinks = () => {
        const linksArr = getLinksByText({ linksText: links })

        setLinkList(linksArr)
    }

  return (
    <div className='supplyOrderItemLinks'>
        {
            linkList && linkList.length > 0 ?
                linkList.map((link, item) => {
                    return (
                        <SupplyOrderItemLink
                            key={item}
                            link={link}
                        />
                    )
                })
            : ''
        }
    </div>
  )
}

export default SupplyOrderItemLinks